import { useState, useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { AvatarProps } from "./types";

/**
 * 頭像組件
 * 提供懶加載、模糊效果和回退選項的用戶頭像
 */
export function Avatar({
  src,
  alt,
  size = "md",
  className = "",
  fallbackText = "?",
}: AvatarProps) {
  // 使用 Tailwind CSS 類名替代 tokens 變數
  const [hasError, setHasError] = useState(false);

  // 重設錯誤狀態當圖片來源變更時
  useEffect(() => {
    setHasError(false);
  }, [src]);

  // 根據尺寸設定樣式
  let sizeClasses = "";
  switch (size) {
    case "xs":
      sizeClasses = "w-8 h-8";
      break;
    case "sm":
      sizeClasses = "w-10 h-10";
      break;
    case "md":
      sizeClasses = "w-12 h-12";
      break;
    case "lg":
      sizeClasses = "w-16 h-16";
      break;
    default:
      sizeClasses = "w-12 h-12";
  }

  // 如果沒有 src 或加載失敗，顯示回退頭像
  if (!src || hasError) {
    const firstChar = fallbackText.charAt(0).toUpperCase();

    return (
      <div
        className={`${sizeClasses} rounded-full bg-primary-500 flex items-center justify-center text-white shadow-sm ${className}`}
      >
        {firstChar}
      </div>
    );
  }

  return (
    <div className={`${sizeClasses} ${className}`}>
      <LazyLoadImage
        src={src}
        alt={alt}
        effect="blur"
        style={{ borderRadius: "8px" }}
        className="w-full h-full object-cover shadow-sm border-2 border-white dark:border-gray-700"
        onError={() => setHasError(true)}
        threshold={100}
        placeholderSrc="/assets/placeholder-avatar.jpg"
        wrapperClassName="overflow-hidden rounded-full"
      />
    </div>
  );
}
